import { ACTIONS, keyLabel, saveControlSettings, type ControlSettings } from './input';
import type { Layout } from './layout';

function clamp(n: number, lo: number, hi: number): number {
  return Math.min(hi, Math.max(lo, n));
}

export function initSettingsPanel(
  layout: Layout,
  getSettings: () => ControlSettings,
  onChange: (settings: ControlSettings) => void,
  onOpenChange: (open: boolean) => void,
): void {
  function refreshInputs(): void {
    const s = getSettings();
    for (const action of ACTIONS) layout.keybindInputs[action].value = keyLabel(s.keybindings[action]);
    layout.dasInput.value = String(s.das);
    layout.arrInput.value = String(s.arr);
  }

  function open(): void {
    refreshInputs();
    layout.settingsBackdrop.hidden = false;
    onOpenChange(true);
  }
  function close(): void {
    layout.settingsBackdrop.hidden = true;
    onOpenChange(false);
  }

  layout.settingsBtn.addEventListener('click', open);
  layout.settingsClose.addEventListener('click', close);
  layout.settingsBackdrop.addEventListener('click', (e) => {
    if (e.target === layout.settingsBackdrop) close();
  });

  for (const action of ACTIONS) {
    const input = layout.keybindInputs[action];
    input.addEventListener('click', () => {
      input.value = 'Press a key…';
      input.classList.add('capturing');
      const capture = (e: KeyboardEvent): void => {
        e.preventDefault();
        window.removeEventListener('keydown', capture, true);
        input.classList.remove('capturing');
        if (e.code === 'Escape') {
          refreshInputs();
          return;
        }
        const settings = getSettings();
        const next: ControlSettings = { ...settings, keybindings: { ...settings.keybindings, [action]: e.code } };
        saveControlSettings(next);
        onChange(next);
        refreshInputs();
      };
      window.addEventListener('keydown', capture, true);
    });
  }

  layout.dasInput.addEventListener('change', () => {
    const settings = getSettings();
    const das = clamp(parseInt(layout.dasInput.value, 10) || settings.das, 1, 200);
    const next = { ...settings, das };
    saveControlSettings(next);
    onChange(next);
    refreshInputs();
  });
  layout.arrInput.addEventListener('change', () => {
    const settings = getSettings();
    const parsed = parseInt(layout.arrInput.value, 10);
    const arr = clamp(Number.isNaN(parsed) ? settings.arr : parsed, 0, 100);
    const next = { ...settings, arr };
    saveControlSettings(next);
    onChange(next);
    refreshInputs();
  });

  refreshInputs();
}
